import { Alert, Snackbar } from "@mui/material";
import { useState } from "react";
import type { PremiseConfig } from "@shared/types/foyer";
import { PageContainer, PageHeader } from "../components/PageHeader";
import PremiseLicensesCard from "../components/PremiseLicensesCard";

/**
 * The products a place has bought. Buying one is what makes its section appear
 * in the menu — the nav reads the same licences the table on this page writes.
 *
 * Used to also carry a "Typical combinations" hint card and a read-only
 * per-product reference list (icon, blurb, "Adds: …") below the licences
 * table. Both removed 2026-09-07 (Sigge): neither was ever the place that
 * WROTE anything - `PremiseLicensesCard` already is, and was already the
 * only editable surface (see its own history: the switches that used to
 * write licences too, with `quantity: 0` as a placeholder, are long gone).
 * The reference blurb's "what does each product unlock" text has no home
 * left on this page; it wants one in a future pass, not invented here.
 */
export default function PremiseProductsPage({
  premise,
}: {
  premise: PremiseConfig;
}) {
  const [msg, setMsg] = useState<string | null>(null);
  const [tick] = useState(0);

  return (
    <PageContainer>
      <PageHeader title="Products" />

      <Snackbar
        open={!!msg}
        autoHideDuration={2500}
        onClose={() => setMsg(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {msg ? <Alert severity="success">{msg}</Alert> : undefined}
      </Snackbar>

      {/* The ONLY way to grant anything. The switches that used to sit below
          wrote licences too, with `quantity: 0` as a placeholder — so a
          product was turned on in one place and its amount set in another,
          and the two could disagree. See `docs/premise-products-consolidation.md`. */}
      <PremiseLicensesCard key={tick} premiseId={premise.premiseId} />
    </PageContainer>
  );
}
